module.exports = __webpack_public_path__ + "img/dbf.ec4d580e.svg";